/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamEvaluationResult } from './oralExamEvaluationResult';

export type GenericApiResponseOralExamEvaluationResultData = OralExamEvaluationResult | null;
